import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { getInterestRegistration, deleteInterestRegistration, updateStatus } from '../actions/InterestRegistrationActions';
import { Pane, Heading, Text, Badge, Card, Button, SelectField, TextareaField, toaster } from 'evergreen-ui';

const statusColors = {
    'pending': 'neutral',
    'selected': 'blue',
    'notified': 'orange',
    'ordered': 'green',
    'cancelled': 'red'
};

const statusLabels = {
    'pending': 'În așteptare',
    'selected': 'Selectat',
    'notified': 'Notificat',
    'ordered': 'Comandat',
    'cancelled': 'Anulat'
};

class ViewInterestRegistration extends Component {
    state = {
        newStatus: '',
        notes: ''
    }

    componentDidMount() {
        const { id } = this.props.match.params;
        this.props.dispatch(getInterestRegistration(id));
    }

    componentDidUpdate(prevProps) {
        if (prevProps.current !== this.props.current && this.props.current) {
            this.setState({
                newStatus: this.props.current.status || 'pending',
                notes: this.props.current.notes || ''
            });
        }
    }

    handleStatusUpdate = () => {
        const { id } = this.props.match.params;
        this.props.dispatch(updateStatus(id, this.state.newStatus, this.state.notes));
        toaster.success('Status actualizat!');
    }

    handleDelete = () => {
        if (window.confirm('Ești sigur că vrei să ștergi această înregistrare?')) {
            const { id } = this.props.match.params;
            this.props.dispatch(deleteInterestRegistration(id));
        }
    }

    render() {
        const { current } = this.props;

        if (!current || !current.id) {
            return <Text>Se încarcă...</Text>;
        }

        return (
            <Pane>
                <Pane display="flex" justifyContent="space-between" alignItems="center" marginBottom={24}>
                    <Heading size={700}>Înregistrare Interes #{current.id}</Heading>
                    <Badge color={statusColors[current.status]} size="large">
                        {statusLabels[current.status] || current.status}
                    </Badge>
                </Pane>

                <Pane display="flex" gap={24}>
                    <Card background="tint2" padding={24} flex={1}>
                        <Heading size={500} marginBottom={16}>Detalii Client</Heading>
                        
                        <Pane marginBottom={12}>
                            <Text size={300} color="muted">Nume</Text>
                            <Text display="block" size={500}>
                                {current.user?.name || 'N/A'}
                            </Text>
                        </Pane>

                        <Pane marginBottom={12}>
                            <Text size={300} color="muted">Email</Text>
                            <Text display="block" size={500}>{current.user?.email || 'N/A'}</Text>
                        </Pane>

                        <Pane marginBottom={12}>
                            <Text size={300} color="muted">Telefon</Text>
                            <Text display="block" size={500}>{current.user?.phone || 'N/A'}</Text>
                        </Pane>

                        <Pane marginBottom={12}>
                            <Text size={300} color="muted">ID Utilizator</Text>
                            <Text display="block" size={500}>{current.userId}</Text>
                        </Pane>
                    </Card>

                    <Card background="tint2" padding={24} flex={1}>
                        <Heading size={500} marginBottom={16}>Detalii Campanie</Heading>
                        
                        <Pane marginBottom={12}>
                            <Text size={300} color="muted">Campanie</Text>
                            <Text display="block" size={500}>{current.campaignId}</Text>
                        </Pane>

                        <Pane marginBottom={12}>
                            <Text size={300} color="muted">Înregistrat la</Text>
                            <Text display="block" size={500}>
                                {current.createdAt ? current.createdAt.format('DD.MM.YYYY HH:mm') : 'N/A'}
                            </Text>
                        </Pane>

                        <Pane marginBottom={12}>
                            <Text size={300} color="muted">Ultima modificare</Text>
                            <Text display="block" size={500}>
                                {current.updatedAt ? current.updatedAt.format('DD.MM.YYYY HH:mm') : 'N/A'}
                            </Text>
                        </Pane>

                        <Pane marginBottom={12}>
                            <Text size={300} color="muted">Note</Text>
                            <Text display="block" size={500}>{current.notes || '-'}</Text>
                        </Pane>
                    </Card>
                </Pane>

                <Card background="tint1" padding={24} marginTop={24}>
                    <Heading size={500} marginBottom={16}>Actualizare Status</Heading>
                    
                    <Pane display="flex" gap={16} alignItems="flex-end">
                        <SelectField
                            label="Status nou"
                            value={this.state.newStatus}
                            onChange={e => this.setState({ newStatus: e.target.value })}
                            width={200}
                        >
                            <option value="pending">În așteptare</option>
                            <option value="selected">Selectat</option>
                            <option value="notified">Notificat</option>
                            <option value="ordered">Comandat</option>
                            <option value="cancelled">Anulat</option>
                        </SelectField>

                        <TextareaField
                            label="Note"
                            value={this.state.notes}
                            onChange={e => this.setState({ notes: e.target.value })}
                            flex={1}
                        />

                        <Button appearance="primary" onClick={this.handleStatusUpdate}>
                            Salvează
                        </Button>
                    </Pane>
                </Card>

                <Pane marginTop={24}>
                    <Button intent="danger" onClick={this.handleDelete}>
                        Șterge înregistrarea
                    </Button>
                </Pane>
            </Pane>
        );
    }
}

function mapStateToProps(state) {
    return {
        current: state.interestRegistrations.current
    };
}

export default withRouter(connect(mapStateToProps)(ViewInterestRegistration));
